import { ContactsOrderBy } from './interfaces';

const ACTIONS_NAMESPACE = 'CONTACTS_TABLE';

export const SET_CONTACTS_ORDER_BY = `${ACTIONS_NAMESPACE}__SET_CONTACTS_ORDER_BY`;

export type SetContactsOrderByAction = ReturnType<typeof setContactsOrderBy>;

export const setContactsOrderBy = (contactsOrderBy: ContactsOrderBy) => ({
  type: SET_CONTACTS_ORDER_BY,
  payload: { contactsOrderBy },
});
